import { t } from "../../../../utils/i18n";
// Filter reviews based on hit?.profile?.Id
export const getRating = (profileId, reviews) => {
  if (!profileId || reviews.length === 0) return t("p2p.rating.none");

  const profileReviews = reviews.filter(
    (review) => review.reviewedProfileId === profileId
  );

  if (profileReviews.length === 0) return t("p2p.rating.none");

  const totalProfileReviews = profileReviews.length;
  const totalProfileUpvotes = profileReviews.filter(
    (review) => review.vote === "upvote"
  ).length;

  const rating = (totalProfileUpvotes / totalProfileReviews) * 100;
  return rating.toFixed(1) + "%";
};

export const getTotalRating = (profileId, reviews) => {
  if (!profileId || reviews.length === 0) return "0";

  const profileReviews = reviews.filter(
    (review) => review.reviewedProfileId === profileId
  );

  const totalProfileUpvotes = profileReviews.filter(
    (review) => review.vote === "upvote"
  ).length;

  if (profileReviews.length === 0) return "0";

  const totalProfileReviews = profileReviews.length;
  return totalProfileReviews;
};
